import { IApplicationState } from '../../types/redux';
import { ISeoLink } from '../../types/offersData';

export const getSeoLinks = (state: IApplicationState): ISeoLink[] | undefined => {
  return state.offersData.seo?.seoLinks;
};
